module.exports = __webpack_public_path__ + "img/4.26abe883.png";